import Magnumkpi from '@mc-alberta/magnumkpi'
import { getTraceId } from './traceId'

export default new Magnumkpi({
  source: 'PMUI',
  namespace: 'src.kpi.PMUI',
  traceId: getTraceId(),
  programId: 'SRC'
})
